import React, { FC } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Button, Drawer as DrawerCreate, IconButton, TextField, Typography } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import CloseIcon from '@mui/icons-material/Close';
import { Controller, useForm } from 'react-hook-form';
import { Box } from '@mui/system';
import { useRejectAwardMutation } from 'entities/competitions-b2b';
import { setDrawerName, setDrawerOpen } from '../../ui/model/uiSlice';
import { useResponseHandler } from '../../../shared/hooks';

const RejectAwardDrawerFeature: FC<{ awardPlaceId: number }> = ({ awardPlaceId }) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen, drawerName } = useAppSelector((state) => state.ui);
  const { control, handleSubmit } = useForm<{ reason: string }>();
  const [rejectAward, { data, error }] = useRejectAwardMutation();
  const submit = handleSubmit((data) => {
    rejectAward({ reason_reject: data.reason, awardPlaceId });
    dispatch(setDrawerOpen(false));
    dispatch(setDrawerName(''));
  });

  useResponseHandler(data, error, 'Награда отклонена', 'Ошибка при отклонении награды');

  return (
    <DrawerCreate
      anchor="right"
      open={isDrawerOpen && drawerName === 'REJECT'}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Отклонение награждения
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <Controller
            control={control}
            name="reason"
            render={({ field }) => (
              <TextField
                {...field}
                label="Причина отклонения"
                size="small"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  marginBottom: '24px',
                }}
                value={field.value || ''}
                onChange={field.onChange}
              />
            )}
          />
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <Button
              onClick={submit}
              variant="contained"
              sx={{ textTransform: 'none' }}
            >
              Отклонить
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </DrawerCreate>
  );
};

export { RejectAwardDrawerFeature };
